import {
  Directive,
  HostBinding,
  Input,
} from '@angular/core';

@Directive({
  selector: '[appRevealContent]'
})
export class RevealContentDirective {

  @Input('appRevealContent') isOpen = false;
  @Input() revealMaxHeight: number | string = null;

  @HostBinding('style.display')
  get display(): string {
    return 'block';
  }

  @HostBinding('style.max-height')
  get maxHeight(): string {
    return this.isOpen ? this._openMaxHeight : '0px';
  }

  @HostBinding('style.overflow')
  get overflow(): string {
    return this.isOpen ? 'auto' : 'hidden';
  }

  @HostBinding('style.transition')
  get transition(): string {
    return 'none';
  }

  @HostBinding('attr.aria-hidden')
  get ariaHidden(): string {
    return this.isOpen ? 'false' : 'true';
  }

  private get _openMaxHeight(): string {
    if (typeof this.revealMaxHeight === 'number') { return `${this.revealMaxHeight}px`; }
    if (typeof this.revealMaxHeight === 'string' && this.revealMaxHeight.length > 0) { return this.revealMaxHeight; }

    return '1000px';
  }
}
